import useQueryBuildingPolicies from "ApiLayer/Policies/queryBuildingPolicies";
import classNames from "classnames";
import { PolicyIcon } from "components/atoms/Icon";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { Header } from "components/atoms/Typography";
import MultiselectDropdown from "components/molecules/MultiselectDropdown";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { useEffect, useState } from "react";
import { BuildingSectionProps } from "../BuildingConstruction.constants";

function BuildingPolicies(props: BuildingSectionProps) {
    const buildingModelUid = useBuildingModelUid();
    const { data: buildingPolicies, isLoading } = useQueryBuildingPolicies(buildingModelUid);
    const { setProperties, isEditing } = props;

    const [selectedPolicies, setSelectedPolicies] = useState<{ key: string; name: string }[]>([]);
    const [activePoliciesIds, setActivePoliciesIds] = useState<string[]>([]);

    useEffect(() => {
        if (buildingPolicies?.carbonPolicyOptions) {
            const activePolicies = buildingPolicies.carbonPolicyOptions
                .filter((policy: CarbonPolicy) => policy.usedInLastModelRun === true)
                .map((policy: CarbonPolicy) => ({
                    key: policy.id.toString(),
                    name: policy.name,
                }));

            setSelectedPolicies(activePolicies);
            setActivePoliciesIds(activePolicies.map((policy) => policy.key));
        }
    }, [buildingPolicies]);

    const dropdownItems =
        buildingPolicies?.carbonPolicyOptions
            ?.map((policy: CarbonPolicy) => ({
                key: policy.id.toString(),
                displayValue: `${policy.name}`,
                value: policy.name,
            }))
            .sort((a, b) => a.value.localeCompare(b.value)) || [];

    const handlePolicyChange = (keys: string[]) => {
        setActivePoliciesIds(keys);

        const numericIds = keys.map((id) => parseInt(id, 10));

        setProperties({ carbonPolicyIds: numericIds });
    };

    if (isLoading) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <div className="construction-sidebar__body__header">
                <PolicyIcon />
                <Header size="medium">Carbon Policies</Header>
            </div>

            {!isEditing && (
                <div className={classNames("construction-sidebar__body__section", isEditing && "editing")}>
                    <div
                        className={classNames(
                            "construction-sidebar__body__property",
                            "construction-sidebar__body__stackedList"
                        )}
                    >
                        {selectedPolicies.map((policy) => (
                            <Header key={policy.key} size="small" style={{ color: "var(--audette-gray-500)" }}>
                                {policy.name}
                            </Header>
                        ))}
                        {selectedPolicies.length === 0 && (
                            <Header size="small" style={{ color: "var(--audette-gray-500)" }}>
                                No carbon policies applied
                            </Header>
                        )}
                    </div>
                </div>
            )}
            {isEditing && buildingPolicies?.carbonPolicyOptions && (
                <div className={classNames("construction-sidebar__body__section", "editing")}>
                    {" "}
                    {buildingPolicies.carbonPolicyOptions.length > 0 ? (
                        <MultiselectDropdown
                            items={dropdownItems}
                            selectedKeys={activePoliciesIds}
                            handleChange={handlePolicyChange}
                        />
                    ) : (
                        <div className={classNames("construction-sidebar__body__section", "editing")}>
                            <Header size="small">No applicable policies</Header>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

export default BuildingPolicies;
